import {
  Volume2,
  Languages,
  ShieldCheck,
  FileText,
  Download,
  Code2,
} from 'lucide-react';
import { FeatureCard } from '@/components/feature-card';

const FEATURES = [
  {
    icon: Volume2,
    title: 'Vocalización TTS',
    description:
      'Text-to-Speech de alta calidad con resalte sincronizado tipo karaoke: palabra, oración y párrafo. Control de velocidad y scroll automático.',
  },
  {
    icon: Languages,
    title: 'Multi-idioma',
    description:
      'Lectura en castellano, inglés y más idiomas. Detección automática del idioma de la página con interfaz localizada.',
  },
  {
    icon: ShieldCheck,
    title: 'WCAG 2.2 AA',
    description:
      'Accesibilidad total: compatible con lectores de pantalla, navegación por teclado, touch targets de 44px y preferencias del usuario.',
  },
  {
    icon: FileText,
    title: 'Lectura de PDFs',
    description:
      'Vocaliza PDFs accesibles directamente desde los portales. Botón dedicado junto a cada enlace PDF detectado.',
  },
  {
    icon: Download,
    title: 'Descarga MP3',
    description:
      'Los usuarios pueden descargar el contenido vocalizado en MP3 para escuchar offline. Generado con Piper TTS de alta calidad.',
  },
  {
    icon: Code2,
    title: 'Integración en 1 línea',
    description:
      'Un solo snippet JavaScript antes de </body>. Sin plugins, sin instalación en servidor, 100% cloud. Compatible con Drupal y otros CMS.',
  },
] as const;

export function FeaturesSection() {
  return (
    <section
      id="features"
      className="py-20 sm:py-28 peninsula-texture"
      aria-labelledby="features-heading"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center mb-12">
          <h2 id="features-heading" className="text-3xl font-bold tracking-tight sm:text-4xl">
            Todo lo que necesitas
          </h2>
          <p className="mt-4 text-lg text-muted-foreground">
            Un servicio completo de vocalización diseñado para portales institucionales.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 stagger-children">
          {FEATURES.map((feature) => (
            <FeatureCard
              key={feature.title}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
